var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
export default function StripSignUpBar(props) {
    var _a = useState(""), email = _a[0], setEmail = _a[1];
    var _b = useState(false), alert = _b[0], setAlert = _b[1];
    var fields = props.fields;
    var navigate = useNavigate();
    var routeChange = function () {
        if (!isEmail(email)) {
            setAlert(true);
        }
        else {
            var path = (props.fields.subscribePage || "/subscribe/") + "?email=" + email;
            navigate(path);
            setTimeout(function () {
                setEmail("");
            }, 1000);
        }
    };
    var handleKeyDown = function (event) {
        if (event.key === 'Enter') {
            console.log("key Enter");
            routeChange();
        }
    };
    var isEmail = function (email) {
        return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
    };
    return (React.createElement(motion.div, __assign({ initial: { opacity: 1 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" }, className: "strip sky23-sign-up-bar bg-white component rounded-pill align-self-center "
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: "mx-auto align-items-center d-flex" },
            React.createElement("div", { className: "row text-dark w-100 align-items-center" },
                React.createElement("div", { className: "col d-flex" },
                    React.createElement("input", { className: "form-control text-primary", tabIndex: 0, placeholder: fields.inputPlaceholder ? fields.inputPlaceholder : "", type: "email", value: email, onChange: function (e) { setEmail(e.target.value); setAlert(false); }, onKeyDown: handleKeyDown })),
                React.createElement("div", { className: "col-auto mx-auto" },
                    React.createElement("button", { "aria-label": "Submit", className: "btn btn-icon arrow arrow-right", id: "submitEmail", type: "button", onClick: routeChange })),
                alert &&
                    React.createElement("span", { className: "wrong-email" }, "Please enter a valid email address")))));
}
//<button aria-label="Submit" className="btn btn-icon arrow arrow-right" id="submitEmail" type="button">Submit</button>
